angular.module("app").controller("StylesPageController", [
    '$scope',
    'preloadedStyles',
    'stylesService',
    'errorHandler',
    'logger',
    'settingsService',
    '$sce',
    '$uibModal',
    'preloadedTemplates',
    'templatesService',
    function ($scope, preloadedStyles, stylesService, errorHandler, logger, settingsService, $sce, $modal, preloadedTemplates, templatesService) {

        var setMenu;

        $scope.version = 0;
        $scope.settings = settingsService.getSettings();
        $scope.templates = angular.copy(preloadedTemplates);

        $scope.pick = function (item, callback) {
            var requestOptions = {
                css: {
                    id : item.id,
                    actual_value : item.customColor
                }
            };
            saveStyleChange(requestOptions,callback);
        };

        $scope.generateCss = function (log) {
            stylesService.generateCss().then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.version++;
                        //TODO translate
                        !log && logger.logSuccess("global.generated");
                        if (!!response.data) {
                            return setMenu(angular.copy(response.data))
                        }
                        getStylesMenu();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.trustSrc = function(url) {
            if (!!url) {
                if (url.indexOf("?") == url.lastIndexOf("?")) {
                    (url += "?version=" + new Date().getTime())
                } else {
                    (url += "&version=" + new Date().getTime())
                }
            }
            return $sce.trustAsResourceUrl(url);
        };

        $scope.resetCss = function () {
            stylesService.resetCss().then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.rollback");
                        $scope.generateCss(true);
                        setMenu(angular.copy(response.data));
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.saveChange = function (item) {
            var requestOptions = {
                css: {
                    id : item.id,
                    actual_value : item.actual_value
                }
            };
            saveStyleChange(requestOptions);
        };

        $scope.applyCss = function () {
            stylesService.applyCss().then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.apply");
                        $scope.generateCss(true);
                        response.data && setMenu(angular.copy(response.data));
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.openHelpPopup = function () {
             $modal.open({
                templateUrl: 'views/templates/modals/styles_help_popup.html'
            });
        };

        $scope.previewItemImage = function (menu) {
            $modal.open({
                templateUrl: 'views/templates/modals/previewItemImage.html',
                controller: "PreviewItemImageController",
                resolve: {
                    imageSrc: function () {
                        return menu.uploaded_image
                    }
                }
            });
        };

        $scope.previewTemplateItemImage = function (imageSrc) {
            $scope.previewItemImage({uploaded_image: imageSrc})
        };

        $scope.useTemplate = function (template) {
            stylesService.useTemplate({template_id:template.id}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.used");
                        $scope.generateCss(true);
                        !!response.data ? setMenu(angular.copy(response.data)) : getStylesMenu();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.saveItemImage = function (menu) {
            var requestOptions = {
                css: {
                    id : menu.id,
                    image : menu.uploaded_image
                }
            };
            saveStyleChange(requestOptions)
        };

        $scope.getKey = function (group) {
            if (group && typeof group === "object") {
                return Object.keys(group)[0]
            }
        };

        $scope.isHidden = function () {
            if ($scope.settings.skin == undefined) return false;

            return 158 == $scope.settings.skin.id || 33 == $scope.settings.skin.id;
        };

        function saveStyleChange (requestOptions, callback) {
            stylesService.updateStyleByConfigSkinId(requestOptions).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.updated");
                        var mock = angular.copy(response.data);
                        if (!!mock.global || !!mock.css) {
                            setMenu(mock)
                        } else {
                            getStylesMenu()
                        }
                    } else {
                        errorHandler(response.message)
                    }
                    callback && callback()
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        function getStylesMenu () {
            stylesService.getStylesMenu({status: "published"}).then(
                function (response) {
                    setMenu(angular.copy(response.data));
                },
                function (error) {
                    errorHandler(error.message);
                }
            );
        }

        (setMenu = function (preloadedStyles) {
            $scope.menuItems = angular.copy(preloadedStyles);
        })(preloadedStyles.data);
    }
]);